import { render, staticRenderFns } from "./ContactCollapse.vue?vue&type=template&id=2ada951c&"
import script from "./ContactCollapse.vue?vue&type=script&lang=js&"
export * from "./ContactCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ContactCollapse.vue?vue&type=style&index=0&id=2ada951c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ada951c')) {
      api.createRecord('2ada951c', component.options)
    } else {
      api.reload('2ada951c', component.options)
    }
    module.hot.accept("./ContactCollapse.vue?vue&type=template&id=2ada951c&", function () {
      api.rerender('2ada951c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/ContactCollapse.vue"
export default component.exports